class JwtUtilService {
  static get access_token_key() {
    return "access_token";
  }

  static get refresh_token_key() {
    return "refresh_token";
  }

  static get id_token_key() {
    return "id_token";
  }

  static get code_verifier_key() {
    return "code_verifier";
  }

  static get code_challenge_key() {
    return "code_challenge";
  }

  static getToken() {
    return localStorage.getItem(this.access_token_key);
  }

  static setToken(token) {
    return localStorage.setItem(this.access_token_key, token);
  }

  static removeToken() {
    localStorage.removeItem(this.access_token_key);
  }

  static getRefreshToken() {
    return localStorage.getItem(this.refresh_token_key);
  }

  static setRefreshToken(token) {
    localStorage.setItem(this.refresh_token_key, token);
  }

  static removeRefreshToken() {
    localStorage.removeItem(this.refresh_token_key);
  }

  static getIdToken() {
    return localStorage.getItem(this.id_token_key);
  }

  static setIdToken(token) {
    localStorage.setItem(this.id_token_key, token);
  }

  static removeIdToken() {
    localStorage.removeItem(this.id_token_key);
  }

  static getCodeVerifier() {
    return window.parent.localStorage.getItem(this.code_verifier_key);
  }

  static setCodeVerifier(token) {
    window.parent.localStorage.setItem(this.code_verifier_key, token);
  }

  static removeCodeVerifier() {
    window.parent.localStorage.removeItem(this.code_verifier_key);
  }

  static getCodeChallenge() {
    return window.parent.localStorage.getItem(this.code_challenge_key);
  }

  static setCodeChallenge(token) {
    window.parent.localStorage.setItem(this.code_challenge_key, token);
  }

  static removeCodeChallenge() {
    window.parent.localStorage.removeItem(this.code_challenge_key);
  }

  static setClientID(clientID) {
    localStorage.setItem("client-id", clientID);
  }

  static getClientID() {
    return localStorage.getItem("client-id");
  }

  static removeClientID() {
    localStorage.removeItem("client-id");
  }

  static deleteAllCookies() {
    // Get all cookies in the browser
    let cookies = document.cookie.split(";");

    // Loop through all cookies
    for (let i = 0; i < cookies.length; i++) {
      // Get the name of the current cookie
      let cookieName = cookies[i].split("=")[0];
      // Set the cookie's expiration date to a past date
      document.cookie =
        cookieName + "=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";
    }
  }
}

export default JwtUtilService;
